<template>
	<b-modal
		hide-footer
		ref="modal-view"
		size="lg"
		:title="
			modelId > 0
				? $t('serviceType.edit')
				: $t('serviceType.new')
		"
	>
		<b-card no-body>
			<b-tabs no-fade pills card small :vertical="vertical" nav-class="nav-style">
				<b-tab title="General" active>
					<b-overlay :show="loading" no-wrap></b-overlay>
					<b-form @submit="onSubmit">
						<FormGroupBox :title="$t('global.info')">
							<b-form-row>
								<b-form-group
									class="col-lg-6 col-12"
									:label="$t('serviceType.name')"
								>
									<b-form-input
										type="text"
										size="sm"
										v-model="modelInfo.name"
										required
									/>
								</b-form-group>
								<b-form-group
									class="col-lg-6 col-12"
									:label="$t('serviceType.code')"
								>
									<b-form-input
										type="text"
										size="sm"
										v-model="modelInfo.code"
										required
									/>
								</b-form-group>
							</b-form-row>
							<b-form-row>
								<b-form-group
									class="col-lg-6 col-12"
									:label="$t('serviceType.category')"
								>
								<b-form-select
									size="sm"
									v-model="modelInfo.serviceTypeCategoryId"
									:options="categoryOpts"
								/>
								</b-form-group>
								<b-form-group
									class="col-lg-6 col-12"
									:label="$t('serviceType.serviceType')"
								>
									<b-form-select
									size="sm"
									v-model="modelInfo.serviceType"
									:options="serviceTypesOptions"
								/>
								</b-form-group>
								<b-form-group
									class="col-lg-3 col-12"
									:label="$t('serviceType.maxPax')"
								>
									<b-form-input
										type="text"
										size="sm"
										v-model="modelInfo.maxPax"
										required
									/>
								</b-form-group>
								<b-form-group
									class="col-lg-3 col-12"
									:label="$t('serviceType.maxSuiteCases')"
								>
									<b-form-input
										type="text"
										size="sm"
										v-model="modelInfo.maxSuitecases"
										required
									/>
								</b-form-group>
							</b-form-row>

							<b-form-row>
								<b-form-group
									class="col-12"
									:label="$t('global.description')"
								>
									<b-textarea
										type="text"
										size="sm"
										v-model="modelInfo.description"
									/>
								</b-form-group>
							</b-form-row>
						</FormGroupBox>
						<hr />
						<div class="text-right">
							<b-button variant="primary" type="submit">{{
								modelId > 0
									? $t("global.update")
									: $t("global.save")
							}}</b-button>
						</div>
					</b-form>
				</b-tab>
			</b-tabs>
		</b-card>
	</b-modal>
</template>

<script>
import FormGroupBox from "../../helpers/FormGroupBox.vue";
import Resize from "../../helpers/Resize.js";

export default {
	mixins: [Resize],
	props: {
		successCallback: {
			type: Function,
			required: false,
			default: () => {}
		}
	},
	components: { FormGroupBox },
	data() {
		let defaultModelInfo = {
			id: -1,
			name:"",
			maxPax:1,
			maxSuitecases:1,
			category:"",
			description:"",
			serviceType:"",
			serviceTypeCategoryId:"",
			status: "active"
		};
		return {
			modelId: -1,
			modelInfo: { ...defaultModelInfo },
			defaultModelInfo: { ...defaultModelInfo },
			loading: true,
			serviceTypesOptions: [
				{ value: "private", text: this.$t("global.private") },
				{ value: "shared", text: this.$t("global.shared")}
			],
		};
	},
	computed: {
		categoryOpts(){
			return this.$root.auxVars.serviceTypesCategoriesOpts;
		}
	},
	methods: {
		onSubmit(event) {
			event.preventDefault();
			if (this.$listeners.submit) {
				this.$listeners.submit(event);
				return;
			}
			this.loading = true;
			let rParams = {
				url:
					this.modelId > 0
						? `/service-types/${this.modelId}`
						: "/service-types",
				method: this.modelId > 0 ? "put" : "post"
			};

			rParams["data"] = this.modelInfo;
			this.$root.api
				.request(rParams)
				.then(res => {
					this.$root.showAlert(
						rParams.method == "post"
							? this.$t("global.registeredSuccess")
							: this.$t("global.doneSuccessfully")
					);
					if (res.data.id) this.loadModel(res.data.id);
					setTimeout(() => {
						this.successCallback(res);
					}, 0);
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.loading = false;
				});
		},
		loadModel(id) {
			this.modelId = id;
			this.$refs["modal-view"].show();
			this.fetchModel();
		},
		fetchModel() {
			if (this.modelId > 0) {
				this.loading = true;
				this.$root.api
					.get(`/service-types/${this.modelId}`)
					.then(res => {
						this.modelInfo = { ...res.data };
						this.loading = false;
					})
					.catch(this.$root.handleRequestError);
			} else {
				this.modelInfo = { ...this.defaultModelInfo };
				this.loading = false;
			}
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['serviceTypesCategoriesOpts']})
	}
};
</script>

<style></style>
